import * as React from "react";

import { Box, Typography } from "@mui/material";

export default function DisabledQuizType() {
	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
					textAlign: "center",
				}}
			>
				<Typography
					variant="h5"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
						textAlign: "center",
						flexDirection: "column",
					}}
				>
					<Box>The Quiz you are trying to access is not available.</Box>
					<Box>Please contact your training organisation to give you access to a new link.</Box>
				</Typography>
			</Box>
		</React.Fragment>
	);
}
